/**
 * @description 登录、获取用户信息、退出登录、清除token逻辑，不建议修改
 */
import { md5 } from 'js-md5'
import { useCommonStore } from './common'
import { getUserInfo, login, logout } from '/@/api/system/user'
import { getLocal, saveLocal, witDecode } from '/@/utils'
import { isArray, isString } from '/@/utils/validate.ts'
import { useMessageStore } from '/@/store/modules/message'


const tokenName = 'access_token'
const refreshTokenName = 'refresh_token'

export const useUserStore = defineStore('user', {
  state: (): any => ({
    userInfo: getLocal('userInfo'),
    token: getLocal(tokenName),
    refresh: getLocal(refreshTokenName),
    username: '',
  }),
  getters: {},
  actions: {
    // 设置用户信息
    setUserInfo(userInfo: any) {
      this.userInfo = userInfo
      saveLocal('userInfo', userInfo)
    },
    /**
     * @description 设置token
     * @param {*} token
     */
    setToken(token: string, refresh: string) {
      this.token = token
      this.refresh = refresh
      saveLocal(tokenName, token)
      saveLocal(refreshTokenName, refresh)
    },
    /**
     * @description 设置用户名
     * @param {*} username
     */
    setUsername(username: string) {
      this.username = username
    },
    /**
     * @description 设置token并发送提醒
     * @param {string} token 更新令牌
     * @param {string} tokenName 令牌名称
     */
    async afterLogin(token: string, refresh: string, tokenName: string, userId: any, form: any) {
      // const commonStore = useCommonStore()
      if (token) {
        this.setToken(token, refresh)
        // commonStore.init()
        await this.getUserInfo()
      } else {
        const err = `登录接口异常，未正确返回${tokenName}...`
        throw err
      }
    },
    /**
     * @description 登录
     * @param {*} form
     */
    async login(form: any) {
      // const {
      //   data: { [tokenName]: access, user_id: userId },
      // } = await login(form)
      const res = await login(form)
      await this.afterLogin(res.data.access, res.data.refresh, tokenName, res.data.userId, form)
    },
    /**
     * @description 获取用户信息接口 这个接口非常非常重要，如果没有明确底层前逻辑禁止修改此方法，错误的修改可能造成整个框架无法正常使用
     * @returns
     */
    async getUserInfo() {
      const res = await getUserInfo()
      const { user, name, role } = res.data
      if (
        (user && !isString(user.userName)) ||
        (role && !isArray(role))
      ) {
        const err = 'getUserInfo接口异常'
        $baseMessage(err, 'error')
        throw err
      } else {
        this.setUserInfo(res.data)
        if (name) this.setUsername(name)
      }
    },
    /**
     * @description 退出登录
     */
    async logout() {
      await logout({ refresh: this.refresh })
      await this.resetAll()
      uni.reLaunch({
        url: `/pages/login/index`,
      })
    },
    /**
     * @description 重置token、roles、permission、router、tabsBar等
     */
    async resetAll() {
      this.setToken('', '')
      this.setUsername('')
      const messageStore = useMessageStore()
      messageStore.closeWebSocket()
      messageStore.setMessageList([])
      messageStore.setTargetType('')
      messageStore.setUnreadNum(0)
    },
  },
})
